export default function () {
  return {
    config: {},
    loading: false,
  }
}
